export default __webpack_public_path__ + "static/media/08_tag_hot-spring.ab672acc.svg";